import React from 'react';
import Required from '../../components/FormElements/Required';

interface IIncorporationFormHeading
  extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  additionalText?: string;
  isRequired?: boolean;
}

const IncorporationFormHeading = ({
  className,
  text,
  additionalText,
  children,
  isRequired,
}: IIncorporationFormHeading) => {
  return (
    <div className={className}>
      <div className="flex-col gap-2">
        <h2 className="text-xl font-bold text-neutral-1 pb-2">{text}</h2>
        {additionalText ? (
          <span className="body-15-regular text-neutral-2">
            {additionalText}
            {isRequired ? <Required /> : null}
          </span>
        ) : null}
      </div>
      {children}
    </div>
  );
};
export { IncorporationFormHeading };
